import { z } from 'zod'

import { DateZod } from '../common'

import {
  SupportBlockingZod,
  SupportCategoryZod,
  SupportLinearTicketZod,
  SupportLineZod,
  SupportPersonZod,
  SupportStatusZod,
} from './support-request-zod'

export const SupportAlertZod = z.object({
  at: DateZod,
  by: z.string(),
  audience: SupportLineZod.array(),
})
export type SupportAlert = z.infer<typeof SupportAlertZod>

export const SupportSummaryZod = z.object({
  request: z.string(),
  blocking: z.string().nullable(),
  done: z.string(),
  next: z.string(),
  generatedAt: DateZod,
  coveredUntil: DateZod,
})
export type SupportSummary = z.infer<typeof SupportSummaryZod>

export const SupportRequestAgentZod = z.object({
  number: z.number().int(),
  regionId: z.string(),
  centralName: z.string(),
  title: z.string(),
  authorName: z.string(),
  category: SupportCategoryZod,
  blocking: SupportBlockingZod,
  status: SupportStatusZod,
  statusSince: DateZod,
  assignee: SupportPersonZod.nullable(),
  createdAt: DateZod,
  settledAt: DateZod.nullish(),
  lastActivityAt: DateZod,
  lastActivityBy: z.string(),
  lastAlert: SupportAlertZod.nullable(),
  lastExchangeAt: DateZod.nullish(),
  summary: SupportSummaryZod.nullish(),
  summaryPending: z.boolean().nullish(),
  linearTicket: SupportLinearTicketZod.extend({ linkedAt: DateZod, syncedAt: DateZod.nullish() }).nullish(),
})
export type SupportRequestAgent = z.infer<typeof SupportRequestAgentZod>
